<template>
  <q-dialog v-model="dialog" persistent class="alertdialog-area">
    <q-card>
      <q-toolbar :class="props.level">
        <q-avatar>
          <q-icon v-if="props.level === 'error'" name="mdi-close-circle" />
          <q-icon v-else-if="props.level === 'warning'" name="mdi-alert" />
          <q-icon v-else name="mdi-alert-circle" />
        </q-avatar>
        <q-toolbar-title class="text-weight-bold">{{ props.title }}</q-toolbar-title>
      </q-toolbar>
      <q-card-section>
        <div v-for="item of props.text" :key="item" class="main-content">
          <p>{{ item }}</p>
        </div>
      </q-card-section>
      <q-card-actions align="right" class="text-primary">
        <q-btn color="primary" label="OK" @click="dialogOk" />
        <q-btn
          v-if="!confirmation && props.level !== 'error'"
          label="キャンセル"
          outline
          style="color: var(--q-delete); margin-left: 12px"
          @click="dialogClose"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';

interface Props {
  // ダイアログを表示するかどうか
  display: boolean;
  // ダイアログのサイズ可変
  largesize?: boolean;
  // エラーレベル（error、warning、information）
  level: string;
  // ボタンがOKのみのダイアログかどうか
  confirmation?: boolean;
  // ダイアログ内ヘッダータイトル
  title: string;
  // ダイアログ内本文
  text: Array<string>;
}

const props = defineProps<Props>();
const dialog = computed(() => props.display);

const emit = defineEmits<{
  (event: 'confirm'): void;
  (event: 'complete'): void;
  (event: 'close'): void;
}>();

const dialogOk = () => {
  if (props.confirmation || props.level === 'error') {
    emit('complete');
  } else {
    emit('confirm');
  }
};

const dialogClose = () => {
  emit('close');
};
</script>
<style>
.alertdialog-area .q-card {
  min-width: 400px;
  padding: 15px 30px;
}
.alertdialog-area .q-toolbar .q-avatar {
  font-size: 36px;
}

.alertdialog-area .q-toolbar {
  padding: 0;
}

.alertdialog-area .q-toolbar.error .q-icon {
  color: var(--q-redWarning);
  font-size: 34px;
}

.alertdialog-area .q-toolbar.warning .q-icon {
  color: var(--q-warning);
  font-size: 34px;
}

.alertdialog-area .q-toolbar.information .q-icon {
  color: var(--q-info);
  font-size: 34px;
}

.alertdialog-area .q-toolbar .q-toolbar__title {
  font-size: 22px;
  padding-top: 4px;
  line-height: 36px;
  padding-left: 14px;
}

.alertdialog-area .q-card__section {
  padding: 0 40px 10px;
  margin-top: 10px;

  padding: 0 20px 10px;
}

.alertdialog-area .q-card__actions {
  margin-top: 20px;
  justify-content: center;
}

.alertdialog-area .q-btn {
  color: var(--q-delete);
  width: 120px;
}

.alertdialog-area .main-content p {
  margin: 0;
  min-height: 1rem;
}

.alertdialog-area.q-dialog.q-dialog--modal .q-dialog__inner .q-card {
  max-width: 80%;
  width: 400px;

  width: 500px;
}
</style>
